import { render, staticRenderFns } from "./ReturnForms.vue?vue&type=template&id=5494fdb1&scoped=true&"
import script from "./ReturnForms.vue?vue&type=script&lang=js&"
export * from "./ReturnForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5494fdb1",
  null
  
)

export default component.exports